import { request } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType, QueryConfig } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { GoogleAnalyticsConnection } from 'Types/GoogleAnalytics'

type GetGAConnectionResponse = {
  data: Array<GoogleAnalyticsConnection>
}

type QueryFnType = typeof getGAConnections

export const useGoogleAnalyticsConnections = (config?: QueryConfig<QueryFnType>) => {
  const { accountId } = useUserStore()

  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['getGAConnections', accountId],
    queryFn: () => getGAConnections(accountId),
    ...config,
  })

  const data = !query.data || query.data instanceof Error ? [] : query.data?.data

  return { ...query, data }
}

const getGAConnections = (accountId: number): Promise<GetGAConnectionResponse | Error> => {
  return request<GetGAConnectionResponse>({
    url: `google-analytics/${accountId}`,
    method: 'GET',
  })
}
